import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};

  @media (max-width: 768px) {
    .box {
      display: flex;
      flex-direction: column;
      div {
        margin-top: 8px;
        text-align: right;
      }
    }
  }
`;

export const StyledDivExpand = styled.div`
  flex-wrap: wrap;
  align-items: flex-start;
  text-align: center;

  .full-width {
    width: 100%;
  }
  .space-align-container {
    flex-wrap: wrap;
    align-items: flex-start;
    text-align: center;
    width: 100%;
  }
  .alert-button {
    color: #ffc14d;
    background: transparent;
    border-color: #ffc14d;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .alert-button:hover,
  .alert-button:focus {
    color: rgba(255, 193, 77, 0.5);
    border-color: rgba(255, 193, 77, 0.5);
  }
`;

export const ContFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  margin-right: 10px;

  svg {
    margin-right: 2px;
  }

  p {
    margin-right: 10px;
  }
`;
